import styled from "styled-components";
import { useGetProjectSurveyTimesetList } from "../../interfaces/survey";
import React, { useCallback, useEffect, useState } from "react";
import { convertToDayList } from "./commonUtil";
import theme from "../../styles/theme";
import { useGetProjectPointInputTimeList, useSetProjectPointInputTimeTable, useSetProjectTimeInit } from "../../interfaces/point";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import moment from "moment";
import { Button, Checkbox, Collapse } from "@mui/material";
import CommonTab from "../common/CommonTab";

const MainWrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding:0 0.5rem;
    .row {
        padding-top: 0.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
    }
`;

const SurveyTimeList =  styled.ul`
    list-style-type: none;
    width: 100%;
    height: 100%;
    max-height: 100%;
    overflow: auto;
    padding: 0;
    margin: 0;
    cursor: pointer;
    li {
        display: grid;
        grid-template-columns: 1.5rem 10rem 5rem auto;
        gap: 1rem;
        font-size: 1rem;
        line-height: 3rem;
        height: 3rem;
        align-item: center;
    }
    .title {
        border-bottom: 2px solid ${theme.color.black[40]};
    }
    .st_list {
        border-bottom: 1px solid ${theme.color.black[20]};
    }
    .twoLine {
        white-space: break;
        font-size: 0.8rem !important;
        line-height: 0.8rem;
        margin: auto 0;
    }
    .st_list:last-child{
        border:0;
    }
`

const PointCodingTime = ({survey, tid}) => {

    const queryClient = useQueryClient();

    const [dayList, setDayList] = useState([]);
    const [timeList, setTimeList] = useState([]);

    const [delList, setDelList] = useState([]);

    const [tabIndex, setTabIndex] = useState(0);

    const {data, refetch} = useGetProjectPointInputTimeList(tid);
    const {data:surveyTimeList, refetch:surveyRefetch} = useGetProjectSurveyTimesetList(survey&&survey.sid);
    const {mutate:timeInitMutate} = useSetProjectTimeInit();

    const {mutate} = useSetProjectPointInputTimeTable();

    useEffect(()=>{
        refetch();
        surveyRefetch();
    },[tid, survey])

    useEffect(()=>{
        if(data && surveyTimeList){
            const temp = surveyTimeList.map((item)=>moment(item.sdate).format('YYYY-MM-DD(dd)'));
            const set = new Set(temp);
            const dayList = [...set];
            setDayList(dayList)
            const newArr = dayList.map((dItem)=>{
                return surveyTimeList.filter((fItem)=>moment(fItem.sdate).format('YYYY-MM-DD(dd)')===dItem).map((item)=>{
                    const startTime = moment(item.sdate+' '+item.stime);
                    const endTime = moment(item.sdate+' '+item.etime);
                    const target =  data.filter((fItem)=>moment(fItem.sdate+' '+fItem.etime).isBetween(startTime,endTime,undefined,'[]'))
                    return {
                        ...item,
                        timeList: target
                    }
                })
            })
            setTimeList(newArr);
        }
    },[surveyTimeList, data])

    const handleModClick = useCallback((updateItem,is_cod) => {
        const temp = {
            mode: 'PUT',
            seqArr:JSON.stringify(updateItem),
            is_cod:is_cod
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:(is_cod===0?'삭제':'활성화')+' 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteDateClick = useCallback((tid,sdate) => {
        const temp = {
            mode: 'DELETE',
            tid:tid,
            sdate:sdate
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDateInitClick = useCallback((sid,sdate,tid) => {
        const temp = {
            mode: 'DATE_INIT',
            sid: sid,
            sdate: sdate,
            tid: tid,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'초기화 하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleTimeInitClick = useCallback((sid,tid) => {
        const temp = {
            mode: 'INPUT',
            sid:sid,
            tid:tid
        }
        timeInitMutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'초기화하였습니다.',
                            height:'20vh',
                        }
                    )
                    // onClickAway(false);
                }
            }
            )
    })

    const handleCheckBox = (obj) => {
        const delTemp = delList;
        const fIndex = delList.findIndex((item)=>item === obj);
        if(fIndex>-1){
            delTemp.splice(fIndex,1);
        }else{
            delTemp.push(obj);
        }
        setDelList(delTemp);

    }

    return (
        <MainWrap>
            <CommonTab tabList={dayList} onClick={setTabIndex}/>
            <SurveyTimeList>
                { (timeList && timeList.length > 0) && timeList[tabIndex].map((item,index)=>
                    <ListItem key={index} item={item} timeUnit={survey.time_unit} delList={delList} handleCheckBox={handleCheckBox}/>
                )}
            </SurveyTimeList>
            <div className="row">
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleModClick(delList,1)}>선택 활성화</Button>
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleModClick(delList,0)}>선택 삭제</Button>
                {timeList.length>0 && timeList[tabIndex][0].timeList.length > 0 ?
                    <Button variant='contained' style={{width:'100%'}} onClick={()=>handleDeleteDateClick(tid,timeList[tabIndex][0].sdate)}>{dayList[tabIndex]} 삭제</Button>
                    :
                    <Button variant='contained' style={{width:'100%'}} onClick={()=>handleDateInitClick(survey.sid, moment(dayList[tabIndex]).format('YYYYMMDD'), tid)}>{dayList[tabIndex]} 초기화</Button>
                }
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleTimeInitClick(survey.sid,tid)}>전체 초기화</Button>
            </div>
        </MainWrap>
    )

}

const TimeList = styled.ul`
    list-style-type: none;
    width: 100%;
    padding: 0;
    padding-left: 4rem;
    margin: 0;
    cursor: pointer;
    li {
        width: 100%;
        grid-template-columns: 2rem 0.25rem auto;
        gap: 1rem;
        font-size: 1rem;
        line-height: 2.5rem;
        height: 2.5rem;
        align-item: center;
    }
`;

const ListItem = ({item, timeUnit, delList:pList, handleCheckBox}) => {

    const [show, setShow] = useState(false);
    const [delList, setDelList] = useState(false);

    useEffect(()=>{
        setDelList(pList);
    },[pList.length])

    return (
        <React.Fragment>
            <li className='st_list' style={{textDecoration:item.timeList < 1?'line-through':''}}>
                <div/>
                {/* <div onClick={()=>setShow(!show)}>{item.sdate}</div> */}
                <div style={{display:'flex',alignItems:'center'}}  onClick={()=>setShow(!show)}>
                    {item.stime}
                    <span>~</span>
                    {item.etime}
                </div>
                <div onClick={()=>setShow(!show)}>
                    {timeUnit/60}분
                </div>
                <div />
            </li>
            <Collapse in={show}>
            <TimeList>
                {item.timeList.map((tItem,tIndex)=>{
                    const check = (delList && delList.length>0) ? (delList.findIndex((fItem)=>tItem.seq===fItem))>-1: false;
                    return (
                            <li>
                                <div>
                                    <Checkbox 
                                        id="time" 
                                        // checked={check} 
                                        onChange={(e)=>handleCheckBox(tItem.seq)}
                                    />
                                </div>
                                <div>
                                    <span style={{textDecoration:tItem.is_cod===0?'line-through':''}}>{tIndex+1}</span>
                                </div>
                                <div>
                                    <span style={{textDecoration:tItem.is_cod===0?'line-through':''}}>{(tItem.stime+' ~ '+tItem.etime) }</span>
                                </div>
                            </li>
                        )
                    })
                }
            </TimeList>
            </Collapse>
        </React.Fragment>
    )
}

export default PointCodingTime;